import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { EXPERIMENT_FLAG } from '../constants'
import { useExperimentCriteria } from './useExperimentCriteria'

export const useTrackPen7562Experiment = () => {
  const isEligible = useExperimentCriteria()

  useEffect(() => {
    if (isEligible) {
      trackExperimentViewed(EXPERIMENT_FLAG)
    }
  }, [isEligible])
}
